module.exports = process.env.NODE_ENV === 'production' ? require('./build/mocks') : require('./build');



//////////////////
// WEBPACK FOOTER
// ./~/airbnb-prop-types/index.js
// module id = 377
// module chunks = 0